import React from "react";
import AuditContent from "./audit-content.jsx";
import useFetchOptions from "../hooks/use-fetch-options.js";

const ReportContent = ({data}) => {
    const { result = [], animals = [] } = data ?? {};
    const { garrisonLeader } = useFetchOptions();

    return (
        <div>
            {result.map((element, index) => (
                <AuditContent key={index} element={element} animals={animals} garrisonLeader={garrisonLeader}/>
            ))}
        </div>
    );
};

export default ReportContent;